// extracted by mini-css-extract-plugin
export default {"title":"title-qcdKO","text":"text-JD6EG"};